/**
 * Built-in fractal configurations (no user saving)
 */
export const presets = {
    classic: {
        name: 'Classic Green & Blue',
        description: 'Traditional green and blue color scheme',
        color1: '#4CAF50',
        color2: '#2196F3',
        backgroundColor: '#FFFFFF',
    },

    sunset: {
        name: 'Sunset Orange & Yellow',
        description: 'Warm sunset colors with orange and yellow',
        color1: '#FF5722',
        color2: '#FFC107',
        backgroundColor: '#FFFFFF',
    },

    purple: {
        name: 'Purple & Pink',
        description: 'Rich purple and pink color combination',
        color1: '#9C27B0',
        color2: '#E91E63',
        backgroundColor: '#FFFFFF',
    },

    autumn: {
        name: 'Autumn Warmth',
        description: 'Warm autumn-themed color palette',
        color1: '#FF6F00',
        color2: '#D84315',
        backgroundColor: '#FFF8E1',
    },

    ocean: {
        name: 'Ocean Blues',
        description: 'Deep ocean blue color scheme',
        color1: '#0277BD',
        color2: '#00ACC1',
        backgroundColor: '#E0F2F1',
    },

    forest: {
        name: 'Forest Greens',
        description: 'Natural forest green tones',
        color1: '#388E3C',
        color2: '#689F38',
        backgroundColor: '#F1F8E9',
    },
};

/**
 * Get list of preset keys
 * @returns {Array} Array of preset names
 */
export function getPresetNames() {
    return Object.keys(presets);
}

/**
 * Get preset by key
 * @param {string} key - Preset key
 * @returns {Object|null} Preset data or null if not found
 */
export function getPresetByKey(key) {
    return presets[key] || null;
}

/**
 * Get all presets (copy)
 * @returns {Object} Copy of all presets
 */
export function getAllPresets() {
    return { ...presets };
}

/**
 * Validate preset data structure
 * @param {Object} presetData - Preset data to validate
 * @returns {boolean} True if valid preset
 */
export function isValidPreset(presetData) {
    const required = ['evenColor', 'oddColor', 'backgroundColor'];
    return required.every(prop => Object.prototype.hasOwnProperty.call(presetData, prop));
}

/**
 * Apply preset colors to configuration object (geometry parameters preserved)
 * @param {string} presetKey - Preset to apply
 * @param {Object} config - Configuration object to update
 * @returns {boolean} True if preset was applied successfully
 */
export function applyPreset(presetKey, config) {
    const preset = getPresetByKey(presetKey);
    if (!preset) {
        console.warn(`Preset "${presetKey}" not found`);
        return false;
    } // Apply only color parameters, preserve geometry (triangleAngle, recursionDepth, etc.)
    const colorParams = ['color1', 'color2', 'backgroundColor'];
    colorParams.forEach(paramName => {
        if (preset[paramName] !== undefined) {
            config[paramName] = preset[paramName];
        }
    });

    return true;
}
